module.exports = __webpack_public_path__ + "img/HeadsetMicOutlined.1c6f63c3.svg";